import {
  Routes,
  Route,
  useParams,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import Home from "../components/HomeComponents/Home";
import {  useTranslation } from "react-i18next";
import Contact from "../components/ContactForm/Contact";
import Privacy from "../components/PrivacyPolicyComponents/Privacy";
import About from "../components/AboutComponents/About";
import Latest from "../components/LatestComponents/Latest";
// import Event from "../components/EventComponents/Event";
import NewsPage from "../components/LatestComponents/NewsPage";
// import EventsPage from "../components/EventComponents/EventsPage";
import Impressum from "../components/ImpressumComponents/Impressum";

const validLangs = ["en", "de", "al"];

const LanguageWrapper = ({ children }: { children: React.ReactNode }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang && validLangs.includes(lang.toLowerCase())) {
      i18n.changeLanguage(lang.toLowerCase());
    } else {
      i18n.changeLanguage("de");
      navigate("/de", { replace: true });
    }
  }, [lang, i18n, navigate]);

  return <>{children}</>;
};

export const Routing = () => {
  return (
    <div>
          <Routes>
            <Route path="/" element={<Navigate to="/de" replace />} />
            <Route
              path="/:lang"
              element={
                <LanguageWrapper>
                  <Home />
                </LanguageWrapper>
              }
            />
            <Route
              path="/:lang/contact"
              element={
                <LanguageWrapper>
                  <Contact />
                </LanguageWrapper>
              }
            />
            <Route
              path="/:lang/privacy"
              element={
                <LanguageWrapper>
                  <Privacy />
                </LanguageWrapper>
              }
            />
             <Route
              path="/:lang/impressum"
              element={
                <LanguageWrapper>
                  <Impressum />
                </LanguageWrapper>
              }
            />
            <Route
              path="/:lang/about"
              element={
                <LanguageWrapper>
                  <About />
                </LanguageWrapper>
              }
            />
            <Route
              path="/:lang/news"
              element={
                <LanguageWrapper>
                  <Latest />
                </LanguageWrapper>
              }
            />
            <Route
              path="/:lang/news/:title"
              element={
                <LanguageWrapper>
                  <NewsPage />
                </LanguageWrapper>
              }
            />
            {/* <Route
              path="/:lang/events"
              element={
                <LanguageWrapper>
                  <Event />
                </LanguageWrapper>
              }
            /> */}
            {/* <Route
              path="/:lang/events/:title"
              element={
                <LanguageWrapper>
                  <EventsPage />
                </LanguageWrapper>
              }
            /> */}
            <Route path="*" element={<Navigate to="/de" replace />} />
          </Routes>

    </div>
  );
}

export default Routing;
